import React, {useEffect, useRef} from 'react'
import Dialog from "../../Dialog";
import Tr from "translations/Translations";
import {SignatureType} from "../../../constants/SignatureType";
import Endpoints from "../../../constants/Endpoints";
import loadExternalLibrary from "../../../libs/loadExternalLibrary";
import Typography from "../../Typography";
import GridBlock from "../../GridBlock";
import BoldTypography from "../../BoldTypography";


// const useStyle = makeStyles(theme => ({
//     root: {}
// }))

const SUPPORTED_SIG_TYPES = [SignatureType.PERSONAL_ID, SignatureType.QUALIFIED];
const isSupportedSigType = (x) => !!x && SUPPORTED_SIG_TYPES.includes(x)

function Szafir(
    {
        config,
        signatureType,
        setSignatureType
    }) {
    const loadedLibrary = useRef(false);

    const startComponentURIErrorCalback = (error) => {
        config.errorCallback({type: "startComponentURIErrorCalback", error})
    }
    const onLoadError = (error) => {
        config.errorCallback({type: "onLoadError", error})
    }
    const onConfigError = (error) => {
        config.errorCallback({type: "onConfigError", error})
    }
    const onErrorNoExtension = (error, info) => {
        config.errorCallback({type: "onErrorNoExtension", error, info})
    }

    const onErrorNoHostApp = (error, info) => {
        config.errorCallback({type: "onErrorNoHostApp", error, info})
    }

    const taskListErrorCallback = (resultTaskList) => {
        config.errorCallback({type: "taskListErrorCallback", error: resultTaskList})
    }

    const invalidResultCode = (error) => {
        config.errorCallback({type: "invalidResultCode", error})
    }

    const successLoadSzafir = () => {
        window.SZAFIR_SDK.startComponentURI(Endpoints.SERVER_URL + `/js/signature/settings${signatureType === SignatureType.PERSONAL_ID ? "_polish_id" : ""}.xml`, startComponentURISuccessCalback, startComponentURIErrorCalback);
    }

    const startComponentURISuccessCalback = () => {
        config.docContentFunc(signatureType).then((resp) => {
            if (resp) {
                const cfg = config.makeTaskListConfig || {
                    signatureFormat: "PAdES-BES",
                    dataEmbedding: "true"
                }
                var makeTaskList = '<?xml version="1.0" encoding="UTF-8"?><MakeTaskList><MakeSigningTask><MakeSigningTaskProperties><SignatureFormat>' + cfg.signatureFormat
                    + '</SignatureFormat><DataEmbedding>' + cfg.dataEmbedding + '</DataEmbedding></MakeSigningTaskProperties><DataToSign><Base64Binary>' + resp + '</Base64Binary></DataToSign></MakeSigningTask></MakeTaskList>';
                window.SZAFIR_SDK.getTaskList(makeTaskList, function (taskList) {
                    window.SZAFIR_SDK.doTaskList(taskList, taskListSuccessCallback, taskListErrorCallback);
                });
            }
        })
    }


    const taskListSuccessCallback = (resultTaskList) => {
        var xmlDoc = window.jQuery.parseXML(resultTaskList);
        var result = window.jQuery("Result", xmlDoc);
        const code = result.attr('code');
        if (result.attr('code') === "0") {
            const signature = window.jQuery("TaskList SigningTask SigningTaskItem SignatureToCreate Base64Binary", xmlDoc).text();
            config.successCallback(signatureType, signature.replace(/\n/g, ""), null)
        } else {
            var desc = window.jQuery("Description", xmlDoc);
            invalidResultCode({
                resultCode: code,
                result: result.text(),
                descriptionCode: desc.attr("code"),
                description: desc.text(),
            })
        }
    }

    useEffect(() => {
        const loadSzafir = () => {
            window.SZAFIR_SDK.loadSzafir(successLoadSzafir, onLoadError);
        }
        if (isSupportedSigType(signatureType)) {
            if (!loadedLibrary.current) {
                loadExternalLibrary(Endpoints.EXT_JS_LIBRARIES.jquery, "external-lib-jquery").then(() => {
                    loadExternalLibrary(Endpoints.EXT_JS_LIBRARIES.szafir, "external-lib-szafir").then(() => {
                        window.SZAFIR_SDK.config({
                            sdk_location_url: Endpoints.SERVER_URL + "/js/signature/build/",
                            versions_file: "versions.xml",
                            onError: onConfigError,
                            onErrorNoExtension,
                            onErrorNoHostApp,
                            debug: false
                        });
                        loadedLibrary.current = true;
                        loadSzafir();
                    }).catch(e => console.error(e))
                }).catch(e => console.error(e))
            } else {
                loadSzafir();
            }
        }
        // eslint-disable-next-line
    }, [signatureType])

    return (
        <Dialog
            open={isSupportedSigType(signatureType)}
            onClose={() => setSignatureType(null)}
        >
            <GridBlock
                justify="center"
            >
                <BoldTypography>{Tr('szafir_loading_info')}</BoldTypography>
                <Typography>{Tr('szafir_loading_info_2')}</Typography>
            </GridBlock>
        </Dialog>
    )


}

Szafir.propTypes = {}


export default Szafir;
